<template>
  <div class="HintsTemplate animated fadeIn">
    <label class="HintsTemplate__important">Wybrana opcja:</label>
    {{ isEnabled ? 'Prośba o kontakt włączona' : 'Brak prośby o kontakt zwrotny' }}
    <ol v-if="isEnabled"
        class="HintsTemplate__description HintsTemplate__list"
    >
      <li>Użytkownik zostanie poinformowany komunikatem głosowym o zajętej linii.</li>
      <li>
        W zakładce <b>“Połączenia”</b> pojawi się informacja o próbie połączenia
        (treść tej informacji możesz edytować w zakładce <b>Wygląd i konfiguracja ekranów</b>),
        a użytkownik będzie miał możliwość wybrania opcji z prośbą o kontakt zwrotny.
      </li>
      <li>
        Połączenia niezrealizowane będą widoczne na liście połączeń ze statusem: NIEUDANE POŁĄCZENIE TELEFONICZNE.
      </li>
      <li>W przypadku pozostawienia przez użytkownika prośby o kontakt zwrotny, połączenia na liście będą miały status: PROŚBA O KONTAKT.</li>
    </ol>
    <ol v-else
        class="HintsTemplate__description HintsTemplate__list"
    >
      <li>Użytkownik zostanie poinformowany komunikatem głosowym o zajętej linii.</li>
      <li>
        W zakładce <b>Połączenia</b> pojawi się informacja o próbie połączenia
        (treść tej informacji możesz edytować w zakładce <b>Wygląd i konfiguracja ekranów</b>).
      </li>
      <li>
        Połączenia niezrealizowane będą widoczne na liście połączeń ze statusem: NIEUDANE POŁĄCZENIE TELEFONICZNE.
      </li>
    </ol>
  </div>
</template>

<script>
export default {
  name: 'MissedCallRequestForContact',
  props: {
    isEnabled: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
